// /src/views/Compania3.js
import React, { useState } from "react";
import VisualizacionBomberos from "../components/VisualizacionBomberos";
import MenuLateralBombero from "../components/MenuLateralBombero";
import TextBannerUnderLogo from "../components/TextBannerUnderLogo";

export default function Compania3() {
  const [mostrarMenu, setMostrarMenu] = useState(false);
  const [offsetTop, setOffsetTop] = useState(70);

  const handleCitacionesChange = (cantidad) => {
    // cada citación ocupa aprox 48px, eso ya lo tenías
    setOffsetTop(70 + cantidad * 48);
  };

  return (
    <div>
      {/* Botón menú */}
      <button
        onClick={() => setMostrarMenu((prev) => !prev)}
        style={{
          position: "fixed",
          top: 10,
          left: 10,
          zIndex: 2500,
          padding: "6px 10px",
        }}
      >
        ☰ Menú
      </button>

      {/* Menú lateral */}
      {mostrarMenu && (
        <MenuLateralBombero onClose={() => setMostrarMenu(false)} />
      )}

      {/* Logo + banner, ambos bajan según las citaciones */}
      <div
        style={{
          marginTop: offsetTop,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 6,
        }}
      >
        {/* Logo centrado */}
        <img
          src="/logos/logo-compania3.png"
          alt="Logo Tercera Compañía"
          style={{
            maxWidth: "280px",
            width: "min(40vw, 280px)",
            height: "auto",
            display: "block",
          }}
        />

        {/* Banner de texto adaptativo (baja junto con el logo) */}
        <TextBannerUnderLogo cia="Tercera Compañía" />
      </div>

      {/* Vista de bomberos (aquí se pintan las citaciones y avisan la altura) */}
      <VisualizacionBomberos
        companiaFiltro="Tercera Compañía"
        onCitacionesChange={handleCitacionesChange}
      />
    </div>
  );
}
